import React from 'react';

export interface ChartErrorBoundaryProps {
  title?: string;
  children: React.ReactNode;
  onReset?: () => void;
}

interface State {
  hasError: boolean;
}

export class ChartErrorBoundary extends React.Component<ChartErrorBoundaryProps, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[ChartErrorBoundary] "${this.props.title ?? 'Chart'}" threw:`, error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col items-center justify-center gap-3 min-h-[160px]">
          {this.props.title && <p className="text-sm font-medium text-gray-700">{this.props.title}</p>}
          <p className="text-sm text-gray-500">Something went wrong displaying this chart.</p>
          <button
            onClick={this.handleReset}
            className="text-sm text-purple-600 hover:text-purple-800 underline"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChartErrorBoundary;
